import * as Enums from '@playbook-technologies/common-enums';

export const INFLUENCER_TIERS = [
  { name: 'All', value: 999 }, // TODO: need to come up with something better, null is already assigned to None
  Enums.Influencer.Tier.First,
  Enums.Influencer.Tier.Second,
  Enums.Influencer.Tier.Thrid,
  Enums.Influencer.Tier.Fourth,
  Enums.Influencer.Tier.Fifth,
  Enums.Influencer.Tier.Sixth,
  Enums.Influencer.Tier.None,
];
